<div class="custom-content">
    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>
<div *ngIf="displayImage">
    <img [src]="logo" style="display: block;
        margin: auto;
        width: 20%;">
    <div class="flex justify-center items-center w-100" id="card-sections">
        <div class="card" (click)="navegar('articulos/crear')">
            <img alt="Fruto hueso" [src]="planta">
            <div class="card-body" style="text-align: center;">
                <h4>Añadir Artículo</h4>
            </div>
        </div>
    </div>
</div>

<div class="custom-navbar" style="background-color: #168d65 !important;">
    <div class="content">
        <div class="d-flex justify-content-between align-items-center">
            <div style="max-width: 150px; position: relative;top: 6px;"
                class="d-flex justify-content-start align-items-center">
                <div style="margin-left: 7px">
                    <i class="fa fa-bars" (click)="toggleMenu('', $event)" style="
                            color: white;
                            font-size: 1.5em;
                            margin-left: 10px"></i>
                </div>
            </div>


            <div class="header" style="top: 5px;position: relative;">
                <h5>{{dashboardEvent.headerTitle}}</h5>

            </div>

            <div style="color: white; top: 4px;
            position: relative;display: flex">
                <span style="position: relative; top: 4px">{{user.name}}</span>


                <button type="button" class="btn btn-primary" (click)="anexos(menu)"
                    style="margin-left: 8px; max-width: 200px;"><i class="fa fa-cog" aria-hidden="true"></i></button>

            </div>
        </div>
    </div>
</div>

<div class="custom-sidebar" style="background: linear-gradient(to bottom, #1a5744, #168d65) !important;"
    [ngStyle]="{left: isSidebarOpen ? '0px' : '-100px'}">
    <div class="content">

        <div *ngFor="let item of dashboardEvent.menuItemData">
            <app-sidenav-cell [id]="item.id" [text]="item.text" [icon]="item.icon" [isSelected]="item.isSelected"
                [expand]="item.expandable" (cellClick)="onNavItemClick($event, item)"
                (subcellClick)="onSubNavItemClick($event)">
            </app-sidenav-cell>
        </div>
    </div>
</div>

<p-dialog header="{{titleDocumentacion}}" [(visible)]="displayDocumentacion"
    [contentStyle]="{'background-color':'#c8c8c8','min-height':'400px','min-width':'700px'}" />

<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-slideMenu #menu [model]="items" [popup]="true" id="slide-menu-settings"></p-slideMenu>